var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.270363 6.77036C0.630847 6.40988 1.21531 6.40988 1.57579 6.77036L12 17.1946L22.4242 6.77036C22.7847 6.40988 23.3692 6.40988 23.7296 6.77036C24.0901 7.13085 24.0901 7.71531 23.7296 8.07579L12.6527 19.1527C12.2922 19.5132 11.7078 19.5132 11.3473 19.1527L0.270363 8.07579C-0.090121 7.71531 -0.090121 7.13085 0.270363 6.77036Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlue);
export default __webpack_public_path__ + "static/media/arrowDownBlue.162a2e3435d6f53711df9cf5d7c819b9.svg";
export { ForwardRef as ReactComponent };